<template>
  <div class="t-pro-card" v-if="list" @click="$emit('clickTProCard', list.id, list.type, list.h5_link)">
    <div class="tip_mark" v-if="list.tip_mark">
      <!-- <t-tag :txt="list.tip_mark" :STag="false"></t-tag> -->
      <t-trapezoid-tag :txt="list.tip_mark"/>
    </div>
    <div class="sort_name" v-if="list.sort_name">
      <t-tag :txt="list.sort_name" :STag="false"></t-tag>
    </div>
    <!-- ?imageView2/4/w/335/h/220/format/jpg/interlace/1/q/80 -->
    <!-- ?imageMogr2/gravity/Center/thumbnail/!343x180r/crop/343x180 -->
    <img :src="Src"
          alt=""
          :class="{'bm_img': bmImg}"
    >
    <div class="titles_wrap">
      <t-pro-detail-titles
          :title="list.title"
          :subtitle="list.subtitle"
          :mark="list.mark"
          :price="list.price"
          :unit="list.unit"
      ></t-pro-detail-titles>
    </div>
  </div>
</template>

<script>
import TProDetailTitles from '@/components/TProDetailTitles'
import TTag from '@/components/TTag'
import TPrice from '@/components/TPrice'
import TTrapezoidTag from '@/components/TTrapezoidTag'
export default {
  name: 't-pro-card',
  props: {
    list: {
      type: Object,
      default: () => {}
    },
    bmImg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    Imgkey () {
      return this.list.img || this.list.head_pic || this.list.img_list
    },
    Src () {
      if (this.bmImg) {
        return `${this.Imgkey}?imageView2/1/w/670/h/324/format/jpg/interlace/1/q/80`
      } else {
        return `${this.Imgkey}?imageMogr2/gravity/Center/thumbnail/!670x440r/crop/670x440`
      }
    }
  },
  components: {
    TTag,
    TPrice,
    TProDetailTitles,
    TTrapezoidTag
  }
}
</script>

<style lang="less" scoped>
  .t-pro-card {
    position: relative;
    width: 335px;
    padding-bottom: 40px;
    position: relative;
    &:hover {
      cursor: pointer;
    }
    &::after {
      // .line();
    }
    // border-bottom: 1Px solid $background-grey2;
    .tip_mark {
      position: absolute;
      top: 0;
      left: 12px;
    }
    .sort_name {
      position: absolute;
      top: 15px;
      right: 11px;
    }
    img {
      width: 335px;
      height: 220px;
      border-radius: 2px;
      vertical-align: top;
    }
    .bm_img {
      width: 100%;
      height: 162px;
    }
    .titles_wrap {
      // border: 1px solid;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TProCard.vue